import React, { useEffect } from "react";
import {
  Container,
  Typography,
  Box,
  Paper,
  Divider,
  useTheme,
} from "@mui/material";
import GavelIcon from "@mui/icons-material/Gavel";
import StaticPageLayout from "../components/StaticPageLayout";

const TermsConditions = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <StaticPageLayout>
      <Container maxWidth="lg" sx={{ py: { xs: 2, md: 5 } }}>
        <Paper
          elevation={isDark ? 4 : 0}
          sx={{
            p: { xs: 2, md: 4 },
            borderRadius: 3,
            background: isDark
              ? "linear-gradient(145deg, #111927 0%, #0D1117 100%)"
              : "white",
            border: isDark ? "1px solid rgba(255,255,255,0.08)" : "1px solid rgba(0,0,0,0.06)",
          }}
        >
          <Box sx={{ textAlign: "center" }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1.5, mb: 2 }}>
              <GavelIcon 
                sx={{ 
                  fontSize: 40, 
                  color: "primary.lightGreen" 
                }} 
              />
              <Typography 
                variant="h2" 
                component="h1"
                sx={{ 
                  fontWeight: 600,
                  color: isDark ? "primary.headings" : "primary.headings",
                }}
              >
                Terms & Conditions
              </Typography>
            </Box>

            <Typography 
              variant="body1" 
              color="text.secondary"
              sx={{ fontStyle: "italic" }}
            >
              Last Updated: December 31, 2025
            </Typography>
          </Box>

          <Divider sx={{ my: 5, borderColor: isDark ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.12)" }} />

          <Box component="section" sx={{ "& > section": { mb: 4 } }}>

            <section>
              <Typography variant="h3" component="h2" color="primary.lightGreen" gutterBottom>
                1. Acceptance
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: 1.8, fontSize: "1rem" }}>
                By using our platforms, you agree to these Terms.
              </Typography>
            </section>

            <section>
              <Typography variant="h4" component="h2" color="primary.lightGreen" gutterBottom>
                2. Use of Services
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: 1.8, fontSize: "1rem" }}>
                You agree to lawful use without harming others or the platform.
              </Typography>
            </section>

            <section>
              <Typography variant="h4" component="h2" color="primary.lightGreen" gutterBottom>
                3. Intellectual Property
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: 1.8, fontSize: "1rem" }}>
                All content is owned by Aikyam and protected by law.
              </Typography>
            </section>

            <section>
              <Typography variant="h4" component="h2" color="primary.lightGreen" gutterBottom>
                4. Disclaimer
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: 1.8, fontSize: "1rem" }}>
                Services are provided "as is" without warranties.
              </Typography>
            </section>

            <section>
              <Typography variant="h4" component="h2" color="primary.lightGreen" gutterBottom>
                5. Limitation of Liability
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: 1.8, fontSize: "1rem" }}>
                We are not liable for damages arising from use or inability to use services.
              </Typography>
            </section>

            <section>
              <Typography variant="h4" component="h2" color="primary.lightGreen" gutterBottom>
                6. Third-Party Content
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: 1.8, fontSize: "1rem" }}>
                We are not responsible for third-party sites or services.
              </Typography>
            </section>

            <section>
              <Typography variant="h4" component="h2" color="primary.lightGreen" gutterBottom>
                7. Governing Law
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: 1.8, fontSize: "1rem" }}>
                These terms are governed by Indian law, jurisdiction: Ranchi, Jharkhard.
              </Typography>
            </section>

            <section>
              <Typography variant="h4" component="h2" color="primary.lightGreen" gutterBottom>
                8. Modifications
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: 1.8, fontSize: "1rem" }}>
                We may update these terms at any time.
              </Typography>
            </section>

            <section>
              <Typography variant="h4" component="h2" color="primary.lightGreen" gutterBottom>
                9. Contact
              </Typography>
              <Typography variant="body1" paragraph sx={{ lineHeight: 1.8, fontSize: "1rem" }}>
                If you have any questions about these Terms and Conditions, please contact us at:
              </Typography>
              <Typography 
                variant="body1" 
                sx={{ 
                  mt: 1, 
                  fontWeight: 500, 
                  color: "primary.lightGreen",
                  fontSize: "1rem"
                }}
              >
                <strong>Email:</strong> aikyamsolutionindia@gmail.com
              </Typography>
              <Typography 
                variant="body1" 
                sx={{ 
                  mt: 1, 
                  fontSize: "1rem"
                }}
              >
                <strong>Address:</strong> 1st Floor, 1899/1877/A1, Road No. 1, Volya Nagar, Harmus, Ranchi, Jharkhand, 834002
              </Typography>
            </section>

          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ textAlign: "center", color: "text.secondary" }}>
            <Typography variant="body1">
              © {new Date().getFullYear()} Aikyam Solutions. All rights reserved.
            </Typography>
          </Box>
        </Paper>
      </Container>
    </StaticPageLayout>
  );
};

export default TermsConditions;